import { Keuzehulp } from '../keuzehulpen'

const trommelvliesBuisjes: Keuzehulp = {
  title: 'Keuzehulp Trommelvlies-buisjes bij mijn kind',
  basePath: '/trommelvlies-buisjes',
  documentTitle: 'Buisjes',
  routes: [
    {
      path: '',
      routeId: 'P3-001',
      nextRouteId: 'P3-002',
      type: 'intro',
      title: 'Voordat u begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/wel-of-geen-trommelvlies-buisjes-bij-mijn-kind',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die u nodig heeft om de keuzehulp in te vullen',
        },
        {
          title: '15 tot 20 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp',
        },
        {
          title: 'Zoek een rustig plekje',
          description: 'Zodat u zich zonder afleiding kunt concentreren',
        },
        {
          title: 'Bekijk en print uw antwoorden',
          description: 'Aan het einde kunt u uw antwoorden bekijken en printen',
        },
      ],
    },
    {
      path: '/stap-1',
      routeId: 'P3-002',
      nextRouteId: 'P3-003',
      type: 'chapter',
      title: 'De klachten van uw kind',
      subtitle: 'Stap 1',
      description: 'Geef aan welke klachten uw kind heeft en lees informatie daarover.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/tkb-chapter-1.png`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/vraag-1',
      routeId: 'P3-003',
      nextRouteId: 'P3-004',
      type: 'uniqueQuestion',
      title: 'Welke klachten heeft uw kind?',
      subtitle: 'Symptomen',
      answers: [
        {
          title: 'Vocht achter het trommelvlies',
          conditionalRoute: [
            { pivotRouteId: 'P3-004', nextRouteId: 'P3-008' },
            { pivotRouteId: 'P3-015', nextRouteId: 'P3-018' },
            { pivotRouteId: 'P3-022', nextRouteId: 'P3-026' },
          ],
        },
        {
          title: 'Oorontsteking',
          conditionalRoute: [
            { pivotRouteId: 'P3-004', nextRouteId: 'P3-011' },
            { pivotRouteId: 'P3-015', nextRouteId: 'P3-020' },
            { pivotRouteId: 'P3-022', nextRouteId: 'P3-024' },
          ],
        },
        {
          title: 'Beide',
          conditionalRoute: [
            { pivotRouteId: 'P3-004', nextRouteId: 'P3-005' },
            { pivotRouteId: 'P3-015', nextRouteId: 'P3-016' },
            { pivotRouteId: 'P3-022', nextRouteId: 'P3-023' },
          ],
        },
      ],
      description: '<h2>Weet u het niet? Lees dan hier meer:</h2>',
      descriptionAlign: 'left',
      info: [
        {
          urlText: 'Wat merkt u bij vocht achter het trommelvlies?',
          title: 'Wat merkt u bij vocht achter het trommelvlies?',
          content: `
              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat is vocht achter het trommelvlies?</h2>
              <ul style="margin-top: 0;">
                <li>Achter het trommelvlies zit het middenoor. Bij uw kind zit daar vocht.</li>
                <li>Normaal verdwijnt dit vocht via de buis van Eustachius naar de keel (zie plaatje). </li>
                <li> Als deze buis verstopt is, kan het vocht niet weg.</li><li>Door het vocht kan het trommelvlies minder goed bewegen.</li>
                <li>Daardoor kan uw kind minder goed horen.</li><li>Vocht achter het trommelvlies is niet schadelijk. Er gaat in het oor niks kapot.</li>
                <li>Andere namen voor vocht achter het trommelvlies zijn: glue ear, lijmoor of slijmoor.</li>
              </ul>
              <div class="img-wrapper"><img src=${process.env.PUBLIC_URL}/img/tkb-oor-1.jpg><i> Zo ziet het oor er vanbinnen uit. Het vocht zit in het middenoor.</i></div>
              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat merkt u bij vocht achter het trommelvlies?</h2>
              <p style="margin: 0">Uw kind kan 1 of meer van de volgende klachten hebben:</p>
              <ul style="margin-top: 0">
                <li>minder goed horen</li>
                <li>een beetje oorpijn of steken in het oor</li>
                <li>onrustig slapen</li>
              </ul>
              <p style="margin: 0">Als uw kind lang slecht hoort kunt u merken dat uw kind:</p>
              <ul style="margin-top: 0; margin-bottom: 50px;">
                <li>minder goed kan praten dan andere kinderen van dezelfde leeftijd. Als kinderen naar de basisschool gaan, halen ze deze achterstand meestal weer in.</li>
                <li>gedragsproblemen heeft. Uw kind is bijvoorbeeld drukker of juist verlegen.</li>
              </ul>
              <style>.img-wrapper{margin: 40px 0;}i{max-width: 300px;}img{max-width: 100%; margin: 0 20px 20px 0;}@media only screen and (min-width: 768px){.img-wrapper{display: flex; flex-direction: row;}img{max-width: 481px;}}</style>
            `,
        },
        {
          urlText: 'Wat merkt u bij een oorontsteking?',
          title: 'Wat merkt u bij een oorontsteking?',
          content: `
              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat is een oorontsteking?</h2>
              <ul style="margin-top: 0">
                <li>Bij een oorontsteking is het middenoor ontstoken.</li>
                <li>Dit komt doordat er een bacterie of virus in het middenoor zit.</li>
                <li>Een andere naam voor een oorontsteking is een middenoorontsteking.</li>
              </ul>
              <div class="img-wrapper"><img src=${process.env.PUBLIC_URL}/img/tkb-oor-1.jpg><i>Zo ziet het oor er vanbinnen uit.</i></div>
              <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat merkt u bij een oorontsteking?</h2>
              <p style="margin: 0">Een kind kan 1 of meer van de volgende klachten hebben:</p>
              <ul style="margin-top: 0">
                <li>oorpijn</li>
                <li>ziek zijn</li>
                <li>koorts</li>
                <li>slecht slapen</li>
                <li>minder goed horen</li>
                <li>baby’s: over het ontstoken oor wrijven en minder goed drinken</li>
                <li>peuters: moe en hangerig zijn</li>
              </ul>
              <p style="margin-bottom: 50px">Door de klachten voelt een kind zich niet lekker en slaapt het vaak slecht. Dit kan ook gevolgen hebben voor u als ouder. U heeft bijvoorbeeld slaapgebrek en bent bezorgd over uw kind.</p>
              <style>.img-wrapper{margin: 40px 0;}i{max-width: 300px;}img{max-width: 100%; margin: 0 20px 20px 0;}@media only screen and (min-width: 768px){.img-wrapper{display: flex; flex-direction: row;}img{max-width: 481px;}}</style>`,
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-2',
      routeId: 'P3-004',
      nextRouteId: 'P3-005',
      subtitle: 'Stap 2',
      type: 'chapter',
      title: 'De mogelijkheden: <br/>Afwachten',
      description:
        '<p>Hoort uw kind korter dan 3 maanden minder goed en heeft uw kind er weinig last van? Dan kunt u het beste afwachten.<br/> Ook als uw kind niet vaak een oorontsteking heeft, kunt u het beste afwachten.</p><p>Verken wat afwachten voor u en uw kind betekent en welke voor- en nadelen het heeft.</p>',
      image: {
        src: `${process.env.PUBLIC_URL}/img/tkb-chapter-2.png`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vocht-en-ontsteking',
      routeId: 'P3-005',
      nextRouteId: 'P3-006',
      type: 'explanation',
      title: 'Afwachten',
      description: `<h2>Vocht achter het trommelvlies</h2>
          <p>Afwachten betekent dat u wacht tot de klachten vanzelf overgaan. Dit is meestal zo na 3 tot 6 maanden. Soms blijven de klachten langer dan 1 jaar bestaan.</p>
          <p>Er zijn geen medicijnen die ervoor zorgen dat de klachten sneller overgaan.</p>
          <p>Vocht achter het trommelvlies komt vooral voor bij kinderen van 0 tot 5 jaar. Bij kinderen ouder dan 7 jaar komt het minder vaak voor.</p>
          <h3 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat kunt u zelf doen?</h3>
          <ul>
            <li>Probeer duidelijk en niet te snel te praten tegen uw kind.</li>
            <li>Kijk uw kind aan als u tegen uw kind praat.</li>
            <li>Zet achtergrondgeluiden, bijvoorbeeld de televisie, uit als u tegen uw kind praat.</li>
            <li>Vertel op het kinderdagverblijf of op school dat uw kind minder goed hoort.</li>
          </ul>
          <h2 style="margin-top: 42px;">Oorontsteking</h2>
          <p>Afwachten betekent dat u wacht tot uw kind vanzelf minder oorontstekingen krijgt door het ouder worden. Bij oudere kinderen komen oorontstekingen minder vaak voor. Na 2 tot 3 dagen gaat een oorontsteking meestal vanzelf over.</p><p>Sommige kinderen krijgen een loopoor. Er komt dan vocht en soms ook een beetje bloed uit het oor. Dit is niet erg.</p>
          <p>Geef uw kind voldoende paracetamol tegen de pijn.</p><p>Neusspray en neusdruppels helpen niet. Antibiotica zijn meestal niet nodig. Soms kiest uw arts ervoor om toch antibiotica te geven. Bijvoorbeeld als uw kind erg ziek is of jonger dan 6 maanden is.</p>`,
      info: [
        {
          urlText: 'Wat is een loopoor?',
          title: 'Wat is een loopoor?',
          content: `<p>De oorpijn van uw kind kan ineens over zijn. Dit kan komen doordat het trommelvlies is gescheurd. Er kan dan vocht uit het oor komen. We noemen dit een loopoor.</p><p>Het trommelvlies geneest meestal vanzelf. Vaak is het loopoor na 1 week weer over. </p><p>Laat een kind met een loopoor niet zwemmen. Ook niet met oordoppen. Uw kind kan duizelig worden als het met het hoofd onder water gaat. Douchen kan wel gewoon.</p><p>6 van de 100 kinderen krijgen bij een oorontsteking een loopoor.</p><img style="max-width: 50%; margin-bottom: 93px;" src=${process.env.PUBLIC_URL}/img/tkb-6.png />`,
        },
      ],
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-2/vocht-en-ontsteking/wat-kan-ik-verwachten-van-afwachten',
      routeId: 'P3-006',
      nextRouteId: 'P3-007',
      type: 'explanation',
      title: 'Wat kan ik verwachten van afwachten?',
      description: `
          <h2>Vocht achter het trommelvlies</h2>
          <p>75 van de 100 kinderen hebben na 6 maanden geen vocht achter het trommelvlies. Zij horen dan weer goed. 25 van de 100 kinderen hebben na 6 maanden nog steeds vocht achter het trommelvlies of opnieuw klachten.</p>
          <img style="max-width: 100%;" src=${process.env.PUBLIC_URL}/img/tkb-7.png>
          <h2 style="margin-top: 0;">Oorontsteking</h2>
          <ul>
            <li>Klachten door oorontstekingen passen bij de leeftijd van jonge kinderen. Zij krijgen veel virussen en bacteriën voor het eerst in hun lichaam. Zo maakt het lichaam een goede verdediging (afweer) tegen virussen en bacteriën. Als kinderen ouder worden hebben ze daardoor minder vaak oorontsteking.</li>
            <li>Uw kind heeft meer kans op een nieuwe oorontsteking bij afwachten. Kinderen met buisjes krijgen gemiddeld 2 oorontstekingen minder in het eerste half jaar na de operatie dan kinderen zonder buisjes.</li>
            <li>Heeft uw kind een nieuwe oorontsteking? Dan is uw kind waarschijnlijk zieker en heeft het meer oorpijn dan met buisjes.</li>
          </ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-2/vocht-en-ontsteking/voor-en-nadelen-van-afwachten',
      routeId: 'P3-007',
      nextRouteId: 'P3-014',
      type: 'explanation',
      title: 'Voor- en nadelen van afwachten',
      titleAlign: 'center',
      description: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Voordelen:</h2>
          <ul>
            <li>Als uw kind ouder wordt heeft het vanzelf minder kans op oorontsteking.</li>
            <li>De meeste kinderen zijn na 3 tot 6 maanden van vanzelf van hun klachten af.</li>
            <li>U en uw kind hebben niet de ongemakken van een operatie.</li>
            <li>U en uw kind hoeven meestal niet naar het ziekenhuis.</li>
            <li>Uw kind hoeft niet onder narcose. U kunt later toch nog kiezen voor buisjes.</li>
          </ul>
          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Nadelen:</h2>
          <ul>
            <li>Het duurt langer voordat de klachten over zijn dan na een operatie</li>
            <li>Meer kans op oorontstekingen in het eerste halfjaar dan na een operatie.</li>
            <li>Bij een oorontsteking heeft een kind zonder buisjes meer oorpijn en is het zieker.</li>
          </ul>`,
      align: 'left',
      button: 'Volgende',
    },
    {
      path: '/stap-2/vocht',
      routeId: 'P3-008',
      nextRouteId: 'P3-009',
      type: 'explanation',
      title: 'Afwachten',
      description: `
        <p>Afwachten betekent dat u wacht tot de klachten vanzelf overgaan. Dit is meestal zo na 3 tot 6 maanden. Soms blijven de klachten langer dan 1 jaar bestaan.</p><p>Er zijn geen medicijnen die ervoor zorgen dat de klachten sneller overgaan.</p><p>Vocht achter het trommelvlies komt vooral voor bij kinderen van 0 tot 5 jaar. Bij kinderen ouder dan 7 jaar komt het minder vaak voor.</p>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat kunt u zelf doen?</h2>
        <ul>
          <li>Probeer duidelijk en niet te snel te praten tegen uw kind.</li>
          <li>Kijk uw kind aan als u tegen uw kind praat.</li>
          <li>Zet achtergrondgeluiden, bijvoorbeeld de televisie, uit als u tegen uw kind praat.</li>
          <li>Vertel op het kinderdagverblijf of op school dat uw kind minder goed hoort.</li>
        </ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-2/vocht/wat-kan-ik-verwachten-van-afwachten',
      routeId: 'P3-009',
      nextRouteId: 'P3-010',
      type: 'explanation',
      title: 'Wat kan ik verwachten van afwachten?',
      description: `<p>75 van de 100 kinderen hebben na 6 maanden geen vocht achter het trommelvlies. Zij horen dan weer goed. 25 van de 100 kinderen hebben na 6 maanden nog steeds vocht achter het trommelvlies of opnieuw klachten.</p><img style="max-width: 100%;" src=${process.env.PUBLIC_URL}/img/tkb-7.png>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-2/vocht/voor-en-nadelen-van-afwachten',
      routeId: 'P3-010',
      nextRouteId: 'P3-014',
      type: 'explanation',
      title: 'Voor- en nadelen van afwachten',
      description: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Voordelen:</h2>
          <ul>
            <li>De meeste kinderen zijn na 3 tot 6 maanden van vanzelf van hun klachten af.</li>
            <li>U en uw kind hebben niet de ongemakken van een operatie.</li>
            <li>U en uw kind hoeven meestal niet naar het ziekenhuis.</li>
            <li>Uw kind hoeft niet onder narcose. U kunt later toch nog kiezen voor buisjes.</li>
          </ul>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Nadelen:</h2>
          <ul>
            <li>Het duurt langer voordat de klachten over zijn dan na een operatie</li>
          </ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-2/ontsteking',
      routeId: 'P3-011',
      nextRouteId: 'P3-012',
      type: 'explanation',
      title: 'Afwachten',
      description:
        '<p>Afwachten betekent dat u wacht tot uw kind vanzelf minder oorontstekingen krijgt door het ouder worden. Bij oudere kinderen komen oorontstekingen minder vaak voor. Na 2 tot 3 dagen gaat een oorontsteking meestal vanzelf over.</p><p>Sommige kinderen krijgen een loopoor. Er komt dan vocht en soms ook een beetje bloed uit het oor. Dit is niet erg.</p><p>Geef uw kind voldoende paracetamol tegen de pijn.</p><p>Neusspray en neusdruppels helpen niet. Antibiotica zijn meestal niet nodig. Soms kiest uw arts ervoor om toch antibiotica te geven. Bijvoorbeeld als uw kind erg ziek is of jonger dan 6 maanden is.</p>',
      info: [
        {
          urlText: 'Wat is een loopoor?',
          title: 'Wat is een loopoor?',
          content: `<p>De oorpijn van uw kind kan ineens over zijn. Dit kan komen doordat het trommelvlies is gescheurd. Er kan dan vocht uit het oor komen. We noemen dit een loopoor.</p><p>Het trommelvlies geneest meestal vanzelf. Vaak is het loopoor na 1 week weer over. </p><p>Laat een kind met een loopoor niet zwemmen. Ook niet met oordoppen. Uw kind kan duizelig worden als het met het hoofd onder water gaat. Douchen kan wel gewoon.</p><p>6 van de 100 kinderen krijgen bij een oorontsteking een loopoor.</p><img style="max-width: 50%; margin-bottom: 93px;" src=${process.env.PUBLIC_URL}/img/tkb-6.png />`,
        },
      ],
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-2/ontsteking/wat-kan-ik-verwachten-van-afwachten',
      routeId: 'P3-012',
      nextRouteId: 'P3-013',
      type: 'explanation',
      title: 'Wat kan ik verwachten van afwachten?',
      description: `<ul><li>Klachten door oorontstekingen passen bij de leeftijd van jonge kinderen. Zij krijgen veel virussen en bacteriën voor het eerst in hun lichaam. Zo maakt het lichaam een goede verdediging (afweer) tegen virussen en bacteriën. Als kinderen ouder worden hebben ze daardoor minder vaak oorontsteking.</li><li>Uw kind heeft meer kans op een nieuwe oorontsteking bij afwachten. Kinderen met buisjes krijgen gemiddeld 2 oorontstekingen minder in het eerste half jaar na de operatie dan kinderen zonder buisjes.</li><li>Heeft uw kind een nieuwe oorontsteking? Dan is uw kind waarschijnlijk zieker en heeft het meer oorpijn dan met buisjes.</li></ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-2/ontsteking/voor-en-nadelen-van-afwachten',
      routeId: 'P3-013',
      nextRouteId: 'P3-014',
      type: 'explanation',
      title: 'Voor- en nadelen van afwachten',
      description: `
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Voordelen:</h2>
        <ul>
          <li>Als uw kind ouder wordt heeft het vanzelf minder kans op oorontsteking.</li>
          <li>De meeste kinderen zijn na 3 tot 6 maanden van vanzelf van hun klachten af.</li>
          <li>U en uw kind hebben niet de ongemakken van een operatie.</li>
          <li>U en uw kind hoeven meestal niet naar het ziekenhuis.</li>
          <li>Uw kind hoeft niet onder narcose. U kunt later toch nog kiezen voor buisjes.</li>
        </ul>

        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Nadelen:</h2>
        <ul>
          <li>Het duurt langer voordat de klachten over zijn dan na een operatie</li>
          <li>Bij een oorontsteking heeft een kind zonder buisjes meer oorpijn en is het zieker.</li>
        </ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-3',
      routeId: 'P3-014',
      nextRouteId: 'P3-015',
      subtitle: 'Stap 3',
      type: 'chapter',
      title: 'De mogelijkheden: <br/>Operatie',
      description:
        '<p>U kunt met uw arts nadenken over het plaatsen van trommelvlies-buisjes bij uw kind. Bij de operatie krijgt uw kind narcose. De kno-arts plaatst buisjes in het trommelvlies. Buisjes laten na 6 tot 12 maanden meestal vanzelf los.</p><p>Verken wat de operatie voor u en uw kind betekent en welke voor- en nadelen het heeft.</p>',
      align: 'left',
      image: {
        src: `${process.env.PUBLIC_URL}/img/tkb-chapter-3.png`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/operatie',
      routeId: 'P3-015',
      nextRouteId: 'P3-016',
      type: 'explanation',
      title: 'Operatie: trommelvlies-buisjes',
      description: `
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">De operatie</h2>
        <ul>
          <li>Uw kind krijgt narcose. Daardoor heeft uw kind geen pijn tijdens de operatie.</li>
          <li>Een kno-arts plaatst een klein buisje in het trommelvlies van beide oren (zie plaatje). Daarna zuigt de kno-arts het vocht uit het middenoor.</li>
          <li>De operatie duurt 10 minuten.</li>
        </ul>
        <div class="img-wrapper"><img style="display: block; margin: 40px 0;" src=${process.env.PUBLIC_URL}/img/tkb-oor-2.jpg></div>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;"<>Na de operatie</h2>
        <p style="margin-top: 0;">Na de operatie mag uw kind dezelfde dag naar huis. U kunt uw kind pijnstillers geven.</p>
        <p>Er is een kleine kans dat uw kind klachten krijgt door de narcose. Bijvoorbeeld: misselijkheid, overgeven of koorts. De verdovingsarts (anesthesioloog) of verpleegkundige vertelt u hier van te voren meer over. Bespreek het met de arts als u hier zorgen over heeft.</p>
        <p>Uw kind kan met buisjes gewoon douchen en zwemmen. Ook met het hoofd onder water.  Sommige artsen raden aan om de 1e week na de operatie nog niet te zwemmen. Oordoppen worden niet aangeraden, maar als u dit prettig vindt mag uw kind ze wel gebruiken.</p>
        <p>De buisjes laten na 6 tot 12 maanden meestal vanzelf los. Het trommelvlies groeit meestal weer dicht. Soms ontstaat er een klein litteken. Kinderen gaan niet slechter horen door een litteken.</p>
        <p>Kno-artsen plaatsen meestal pas buisjes als een kind ouder is dan 1 jaar.</p>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-3/vocht-en-ontsteking/wat-kan-ik-verwachten-van-trommelvliesbuisjes',
      routeId: 'P3-016',
      nextRouteId: 'P3-017',
      type: 'explanation',
      title: 'Wat kan ik verwachten van trommelvlies-buisjes?',
      description: `
        <p>Trommelvlies-buisjes werken zolang ze in de oren zitten: gemiddeld 6 tot 12 maanden. Kinderen horen beter en hebben minder oorontstekingen. Na het loslaten van de buisjes zijn deze voordelen er niet meer.</p>
        <ul>
          <li>Kinderen kunnen een loopoor krijgen doordat vocht door het buisje het oor uit kan. Bij een loopoor komt er vocht uit het oor. Soms zit er een beetje bloed in het vocht. Dit is niet erg.</li>
          <li>Een kind met buisjes en een loopoor krijgt oordruppels. Laat een kind met een loopoor niet zwemmen.</li>
        </ul>
        <p>26 van de 100 kinderen krijgen een loopoor.</p>
        <img style="max-width: 100%" src=${process.env.PUBLIC_URL}/img/tkb-8.png>
        <p>Bij 20 van de 100 kinderen die buisjes hebben gehad en opnieuw klachten kiezen de ouders weer voor buisjes.</p>
        <img style="max-width: 100%" src=${process.env.PUBLIC_URL}/img/tkb-9.png>
        <p>Bij 3 van de 100 kinderen groeit het trommelvlies niet dicht nadat het buisje heeft losgelaten. Soms moet het trommelvlies met een operatie dichtgemaakt worden, maar meestal hoeft dat niet.</p>
        <img style="max-width: 100%" src=${process.env.PUBLIC_URL}/img/tkb-4.png>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Vocht achter het trommelvlies</h2>
        <ul>
          <li>Een kind heeft na de operatie geen vocht achter het trommelvlies meer en hoort bijna altijd meteen beter.</li>
          <li>Dit beter horen blijft zolang de buisjes in de oren zitten.</li>
          <li>Als de buisjes eruit zijn, kan het gehoor weer slechter worden. Maar dat hoeft niet.</li>
          <li>Het is onzeker of kinderen beter gaan praten of gedragsproblemen verminderen.</li>
        </ul>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Oorontsteking</h2>
        <ul>
          <li>Uw kind heeft minder kans op een nieuwe oorontsteking dan bij afwachten. Kinderen met buisjes krijgen gemiddeld 2 oorontstekingen minder in het eerste half jaar na de operatie dan kinderen zonder buisjes.</li>
          <li>Heeft uw kind een nieuwe oorontsteking? Dan is uw kind waarschijnlijk minder ziek en heeft het minder oorpijn dan zonder buisjes.</li>
        </ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-3/vocht-en-ontsteking/voor-en-nadelen-van-trommelvlies-buisjes',
      routeId: 'P3-017',
      nextRouteId: 'P3-022',
      type: 'explanation',
      title: 'Voor- en nadelen van trommelvlies-buisjes',
      description: `
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Voordelen:</h2>
        <ul>
          <li>Een kind gaat meteen beter horen.</li>
          <li>Een kind hoort 6 tot 12 maanden beter (tot de buisjes loslaten). </li>
          <li>Minder kans op oorontstekingen in de eerste half jaar na de operatie.</li>
          <li>Bij een oorontsteking minder oorpijn en minder ziek. </li>
        </ul>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Nadelen:</h2>
        <ul>
          <li>U en uw kind hebben ongemakken van een operatie.</li>
          <li>Voor de operatie krijgt u een afspraak in het ziekenhuis bij de verdovingsarts of verpleegkundige.</li>
          <li>Er is een kleine kans dat uw kind klachten door de narcose krijgt. Bijvoorbeeld misselijkheid, overgeven of koorts.</li>
          <li>Er is meer kans op een loopoor.</li>
          <li>Gemiddeld werken buisjes 6 tot 12 maanden. Daarna laten ze meestal vanzelf los. </li>
        </ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-3/vocht/wat-kan-ik-verwachten-van-trommelvliesbuisjes',
      routeId: 'P3-018',
      nextRouteId: 'P3-019',
      type: 'explanation',
      title: 'Wat kan ik verwachten van trommelvlies-buisjes?',
      description: `<p>Trommelvlies-buisjes werken zolang ze in de oren zitten: gemiddeld 6 tot 12 maanden. Kinderen horen beter en hebben minder oorontstekingen. Na het loslaten van de buisjes zijn deze voordelen er niet meer.</p><ul><li>Kinderen kunnen een loopoor krijgen doordat vocht door het buisje het oor uit kan. Bij een loopoor komt er vocht uit het oor. Soms zit er een beetje bloed in het vocht. Dit is niet erg.</li><li>Een kind met buisjes en een loopoor krijgt oordruppels. Laat een kind met een loopoor niet zwemmen.</li></ul><p>26 van de 100 kinderen krijgen een loopoor.</p><img style="max-width: 100%" src=${process.env.PUBLIC_URL}/img/tkb-8.png><p>Bij 20 van de 100 kinderen die buisjes hebben gehad en opnieuw klachten kiezen de ouders weer voor buisjes.</p><img style="max-width: 100%" src=${process.env.PUBLIC_URL}/img/tkb-9.png><p>Bij 3 van de 100 kinderen groeit het trommelvlies niet dicht nadat het buisje heeft losgelaten. Soms moet het trommelvlies met een operatie dichtgemaakt worden, maar meestal hoeft dat niet.</p><img style="max-width: 100%" src=${process.env.PUBLIC_URL}/img/tkb-4.png><ul><li>Een kind heeft na de operatie geen vocht achter het trommelvlies meer en hoort bijna altijd meteen beter.</li><li>Dit beter horen blijft zolang de buisjes in de oren zitten.</li><li>Als de buisjes eruit zijn, kan het gehoor weer slechter worden. Maar dat hoeft niet.</li><li>Het is onzeker of kinderen beter gaan praten of gedragsproblemen verminderen.</li></ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-3/vocht/voor-en-nadelen-van-trommelvlies-buisjes',
      routeId: 'P3-019',
      nextRouteId: 'P3-022',
      type: 'explanation',
      title: 'Voor- en nadelen van trommelvlies-buisjes',
      description: `
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Voordelen:</h2>
        <ul>
          <li>Een kind gaat meteen beter horen.</li>
          <li>Een kind hoort 6 tot 12 maanden beter (tot de buisjes loslaten).</li>
        </ul>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Nadelen:</h2>
        <ul>
          <li>U en uw kind hebben ongemakken van een operatie.</li>
          <li>Voor de operatie krijgt u een afspraak in het ziekenhuis bij de verdovingsarts of verpleegkundige.</li>
          <li>Er is een kleine kans dat uw kind klachten door de narcose krijgt. Bijvoorbeeld misselijkheid, overgeven of koorts.</li>
          <li>Er is meer kans op een loopoor.</li>
          <li>Gemiddeld werken buisjes 6 tot 12 maanden. Daarna laten ze meestal vanzelf los. </li>
        </ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-3/ontsteking/wat-kan-ik-verwachten-van-trommelvliesbuisjes',
      routeId: 'P3-020',
      nextRouteId: 'P3-021',
      type: 'explanation',
      title: 'Wat kan ik verwachten van trommelvlies-buisjes?',
      description: `<p>Trommelvlies-buisjes werken zolang ze in de oren zitten: gemiddeld 6 tot 12 maanden. Kinderen horen beter en hebben minder oorontstekingen. Na het loslaten van de buisjes zijn deze voordelen er niet meer.</p><ul><li>Kinderen kunnen een loopoor krijgen doordat vocht door het buisje het oor uit kan. Bij een loopoor komt er vocht uit het oor. Soms zit er een beetje bloed in het vocht. Dit is niet erg.</li><li>Een kind met buisjes en een loopoor krijgt oordruppels. Laat een kind met een loopoor niet zwemmen.</li></ul><p>26 van de 100 kinderen krijgen een loopoor.</p><img style="max-width: 100%" src=${process.env.PUBLIC_URL}/img/tkb-8.png><p>Bij 20 van de 100 kinderen die buisjes hebben gehad en opnieuw klachten kiezen de ouders weer voor buisjes.</p><img style="max-width: 100%" src=${process.env.PUBLIC_URL}/img/tkb-9.png><p>Bij 3 van de 100 kinderen groeit het trommelvlies niet dicht nadat het buisje heeft losgelaten. Soms moet het trommelvlies met een operatie dichtgemaakt worden, maar meestal hoeft dat niet.</p><img style="max-width: 100%" src=${process.env.PUBLIC_URL}/img/tkb-4.png><ul><li>Uw kind heeft minder kans op een nieuwe oorontsteking dan bij afwachten. Kinderen met buisjes krijgen gemiddeld 2 oorontstekingen minder in de eerste half jaar na de operatie dan kinderen zonder buisjes.</li><li>Heeft uw kind een nieuwe oorontsteking? Dan is uw kind waarschijnlijk minder ziek en heeft het minder oorpijn dan zonder buisjes.</li></ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-3/ontsteking/voor-en-nadelen-van-trommelvlies-buisjes',
      routeId: 'P3-021',
      nextRouteId: 'P3-022',
      type: 'explanation',
      title: 'Voor- en nadelen van trommelvlies-buisjes',
      description: `
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Voordelen:</h2>
        <ul>
          <li>Een kind gaat meteen beter horen.</li>
          <li>Een kind hoort 6 tot 12 maanden beter (tot de buisjes loslaten). </li>
        </ul>
        <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Nadelen:</h2>
        <ul>
          <li>U en uw kind hebben ongemakken van een operatie.</li>
          <li>Voor de operatie krijgt u een afspraak in het ziekenhuis bij de verdovingsarts of verpleegkundige.</li>
          <li>Er is een kleine kans dat uw kind klachten door de narcose krijgt. Bijvoorbeeld misselijkheid, overgeven of koorts.</li>
          <li>Er is meer kans op een loopoor.</li>
          <li>Gemiddeld werken buisjes 6 tot 12 maanden. Daarna laten ze meestal vanzelf los. </li>
        </ul>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-4',
      routeId: 'P3-022',
      nextRouteId: 'P3-023',
      type: 'chapter',
      subtitle: 'Stap 4',
      title: 'De mogelijkheden vergelijken',
      description:
        '<p>U bepaalt samen met uw arts wat het beste is voor uw kind. Dit hangt af van wat u belangrijk vindt. Dit kunt u hieronder aangeven. Zet het schuifje bij uw mening. Als u het niet weet, laat het schuifje dan in het midden staan.</p><p>Let op: er komt niet automatisch een antwoord uit. Vult u zelf in wat u het liefst wilt. En hoe zeker u dit weet.</p>',
      image: {
        src: `${process.env.PUBLIC_URL}/img/tkb-chapter-4.png`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vocht-en-ontsteking/verschillen-op-een-rijtje',
      routeId: 'P3-023',
      nextRouteId: 'P3-027',
      type: 'explanation',
      title: 'Verschillen op een rijtje',
      titleAlign: 'center',
      description: `
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Afwachten</th>
              <th>Een operatie</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Wat betekent het?</th>
              <td>Geen trommelvlies-buisjes plaatsen.</td>
              <td>Een operatie waarbij uw kind narcose krijgt. De kno-arts plaatst buisjes in het trommelvlies. Buisjes laten na 6 tot 12 maanden meestal vanzelf los.</td>
            </tr>
            <tr>
              <th>Wat kan ik verwachten?</th>
              <td>
                Vocht achter het trommelvlies<br/>
                <ul style="margin-top: 0">
                  <li>75 van de 100 kinderen hebben na 6 maanden geen vocht meer achter het trommelvlies. Zij horen dan weer goed.</li>
                </ul>
                <br/><br/>
                Oorontsteking<br/>
                <ul style="margin-top: 0">
                  <li>Klachten passen bij de leeftijd van jonge kinderen. Bij oudere kinderen komen oorontstekingen minder vaak voor.</li>
                </ul>
              </td>
              <td>
                <ul style="margin-top: 0">
                  <li>26 van de 100 kinderen krijgen een loopoor.</li>
                  <li>Bij 3 van de 100 groeit het trommelvlies niet dicht nadat het buisje heeft losgelaten.</li>
                  <li>Bij 20 van de 100 kinderen die buisjes hebben gehad en opnieuw klachten krijgen, kiezen de ouders weer voor buisjes.</li>
                </ul>
                <br/>
                Vocht achter het trommelvlies<br/>
                <ul style="margin-top: 0">
                  <li>Uw kind hoort bijna altijd meteen beter. Dit blijft zo zolang de buisjes in de oren zitten. Het is onzeker of kinderen beter gaan praten of gedragsproblemen verminderen.</li>
                </ul>
                <br/><br/>
                Oorontsteking<br/>
                <ul style="margin-top: 0">
                  <li>Kinderen met buisjes krijgen gemiddeld 2 oorontstekingen minder in het eerste half jaar na de operatie dan kinderen zonder buisjes.
                  Kinderen met buisjes hebben bij oorontstekingen minder oorpijn en zijn minder ziek tijdens een oorontsteking dan kinderen zonder buisjes.
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Voordelen</th>
              <td>
                <ul>
                  <li>Niet de ongemakken van een operatie.</li>
                  <li>Meestal niet naar het ziekenhuis.</li>
                  <li>Geen kans op klachten door de narcose.</li>
                  <li>U kunt later toch nog kiezen voor buisjes.</li>
                </ul>
              </td>
              <td>
                Vocht achter het trommelvlies
                <ul>
                  <li>Meteen beter horen.</li>
                  <li>6 tot 12 maanden beter horen (tot de buisjes loslaten).</li>
                </ul><br/>
                Oorontsteking
                <ul>
                  <li>Minder kans op oorontstekingen in het eerste half jaar na de operatie.</li>
                  <li>Minder oorpijn en minder ziek bij een oorontsteking in het eerste half jaar na de operatie.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Nadelen</th>
              <td>
                Vocht achter het trommelvlies
                <ul>
                  <li>Het duurt langer voordat de klachten over zijn.</li>
                </ul>
                <br/>
                Oorontsteking
                <ul>
                  <li>Meer kans op oorontstekingen in het eerste half jaar a de operatie.</li>
                  <li>Meer oorpijn en zieker bij een oorontsteking in het eerste half jaar na de operatie.</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Ongemakken van een operatie.</li>
                  <li>Ter voorbereiding op de operatie krijgt u een afspraak in het ziekenhuis bij de verdovingsarts of verpleegkundige.</li>
                  <li>Kans op klachten door de narcose.</li>
                  <li>Meer kans op een loopoor.</li>
                  <li>De meeste buisjes werken 6 tot 12 maanden.</li>
                  <li>Daarna laten de buisjes meestal vanzelf los.</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>`,
      align: 'left',
      button: 'Volgende',
    },
    {
      path: '/stap-4/ontsteking/verschillen-op-een-rijtje',
      routeId: 'P3-024',
      nextRouteId: 'P3-027',
      type: 'explanation',
      title: 'Verschillen op een rijtje',
      align: 'left',
      titleAlign: 'center',
      description: `
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Afwachten</th>
              <th>Een operatie</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Wat betekent het?</th>
              <td>Geen trommelvlies-buisjes plaatsen.</td>
              <td>Een operatie waarbij uw kind narcose krijgt. De kno-arts plaatst buisjes in het trommelvlies. Buisjes laten na 6 tot 12 maanden meestal vanzelf los.</td>
            </tr>
            <tr>
              <th>Wat kan ik verwachten?</th>
              <td>
                Vocht achter het trommelvlies<br/>
                <ul style="margin-top: 0">
                  <li>75 van de 100 kinderen hebben na 6 maanden geen vocht meer achter het trommelvlies. Zij horen dan weer goed.</li>
                </ul><br />
                Oorontsteking<br/>
                <ul style="margin-top: 0">
                  <li>Klachten passen bij de leeftijd van jonge kinderen. Bij oudere kinderen komen oorontstekingen minder vaak voor.</li>
                </ul>
              </td>
              <td>
                <ul style="margin-top: 0">
                  <li>26 van de 100 kinderen krijgen een loopoor.</li>
                  <li>Bij 3 van de 100 groeit het trommelvlies niet dicht nadat het buisje heeft losgelaten.</li>
                  <li>Bij 20 van de 100 kinderen die buisjes hebben gehad en opnieuw klachten krijgen, kiezen de ouders weer voor buisjes.</li>
                </ul>
                <br/>
                Vocht achter het trommelvlies<br/>
                <ul style="margin-top: 0">
                  <li>Uw kind hoort bijna altijd meteen beter. Dit blijft zo zolang de buisjes in de oren zitten. Het is onzeker of kinderen beter gaan praten of gedragsproblemen verminderen.</li>
                </ul>
                <br/><br/>
                Oorontsteking<br/>
                <ul style="margin-top: 0">
                  <li>
                  Kinderen met buisjes krijgen gemiddeld 2 oorontstekingen minder in het eerste half jaar na de operatie dan kinderen zonder buisjes.
                  Kinderen met buisjes hebben bij oorontstekingen minder oorpijn en zijn minder ziek tijdens een oorontsteking dan kinderen zonder buisjes.
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Voordelen</th>
              <td>
                <ul>
                  <li>Niet de ongemakken van een operatie.</li>
                  <li>Meestal niet naar het ziekenhuis.</li>
                  <li>Geen kans op klachten door de narcose.</li>
                  <li>U kunt later toch nog kiezen voor buisjes.</li>
                </ul>
              </td>
              <td>
                Vocht achter het trommelvlies
                <ul>
                  <li>Meteen beter horen.</li>
                  <li>6 tot 12 maanden beter horen (tot de buisjes loslaten).</li>
                </ul><br/>
                Oorontsteking
                <ul>
                  <li>Minder kans op oorontstekingen in het eerste half jaar na de operatie.</li>
                  <li>Minder oorpijn en minder ziek bij een oorontsteking in het eerste half jaar na de operatie.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Nadelen</th>
              <td>
                Vocht achter het trommelvlies
                <ul>
                  <li>Het duurt langer voordat de klachten over zijn.</li>
                </ul><br/>
                Oorontsteking
                <ul>
                  <li>Meer kans op oorontstekingen in het eerste half jaar a de operatie.</li>
                  <li>Meer oorpijn en zieker bij een oorontsteking in het eerste half jaar na de operatie.</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Ongemakken van een operatie.</li>
                  <li>Ter voorbereiding op de operatie krijgt u een afspraak in het ziekenhuis bij de verdovingsarts of verpleegkundige.</li>
                  <li>Kans op klachten door de narcose.</li>
                  <li>Meer kans op een loopoor.</li>
                  <li>De meeste buisjes werken 6 tot 12 maanden.</li>
                  <li>Daarna laten de buisjes meestal vanzelf los.</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>`,
      button: 'Volgende',
    },
    {
      path: '/stap-4/ontsteking/verschillen-op-een-rijtje',
      routeId: 'P3-025',
      nextRouteId: 'P3-026',
      type: 'explanation',
      title: 'Verschillen op een rijtje',
      align: 'left',
      titleAlign: 'center',
      description: `
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Afwachten</th>
              <th>Een operatie</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>>Wat betekent het?</th>
              <td>Geen trommelvlies-buisjes plaatsen.</td>
              <td>Een operatie waarbij uw kind narcose krijgt. De kno-arts plaatst buisjes in het trommelvlies. Buisjes laten na 6 tot 12 maanden meestal vanzelf los.</td>
            </tr>
            <tr>
              <th>Wat kan ik verwachten?</th>
              <td>
                Vocht achter het trommelvlies<br/>
                <ul style="margin-top: 0">
                  <li>75 van de 100 kinderen hebben na 6 maanden geen vocht meer achter het trommelvlies. Zij horen dan weer goed.</li>
                </ul>
                <br/><br/>
                Oorontsteking<br/>
                <ul style="margin-top: 0">
                  <li>
                    Klachten passen bij de leeftijd van jonge kinderen. Bij oudere kinderen komen oorontstekingen minder vaak voor.
                  </li>
                </ul>
              </td>
              <td>
                <ul style="margin-top: 0">
                  <li>26 van de 100 kinderen krijgen een loopoor.</li>
                  <li>Bij 3 van de 100 groeit het trommelvlies niet dicht nadat het buisje heeft losgelaten.</li>
                  <li>Bij 20 van de 100 kinderen die buisjes hebben gehad en opnieuw klachten krijgen, kiezen de ouders weer voor buisjes.</li>
                </ul>
                <br/>
                Vocht achter het trommelvlies<br/>
                <ul style="margin-top: 0">
                  <li>Uw kind hoort bijna altijd meteen beter. Dit blijft zo zolang de buisjes in de oren zitten. Het is onzeker of kinderen beter gaan praten of gedragsproblemen verminderen.</li>
                </ul>
                <br/><br/>
                Oorontsteking<br/>
                <ul style="margin-top: 0">
                  <li>Kinderen met buisjes krijgen gemiddeld 2 oorontstekingen minder in het eerste half jaar na de operatie dan kinderen zonder buisjes.
                  Kinderen met buisjes hebben bij oorontstekingen minder oorpijn en zijn minder ziek tijdens een oorontsteking dan kinderen zonder buisjes.
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Voordelen</th>
              <td>
                <ul>
                  <li>Niet de ongemakken van een operatie.</li>
                  <li>Meestal niet naar het ziekenhuis.</li>
                  <li>Geen kans op klachten door de narcose.</li>
                  <li>U kunt later toch nog kiezen voor buisjes.</li>
                </ul>
              </td>
              <td>
                Vocht achter het trommelvlies
                <ul>
                  <li>Meteen beter horen.</li>
                  <li>6 tot 12 maanden beter horen (tot de buisjes loslaten).</li>
                </ul><br/>
                Oorontsteking
                <ul>
                  <li>Minder kans op oorontstekingen in het eerste half jaar na de operatie.</li>
                  <li>Minder oorpijn en minder ziek bij een oorontsteking in het eerste half jaar na de operatie.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Nadelen</th>
              <td>
                Vocht achter het trommelvlies
                <ul>
                  <li>Het duurt langer voordat de klachten over zijn.</li>
                </ul><br/>
                Oorontsteking
                <ul>
                  <li>Meer kans op oorontstekingen in het eerste half jaar a de operatie.</li>
                  <li>Meer oorpijn en zieker bij een oorontsteking in het eerste half jaar na de operatie.</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Ongemakken van een operatie.</li>
                  <li>Ter voorbereiding op de operatie krijgt u een afspraak in het ziekenhuis bij de verdovingsarts of verpleegkundige.</li>
                  <li>Kans op klachten door de narcose.</li>
                  <li>Meer kans op een loopoor.</li>
                  <li>De meeste buisjes werken 6 tot 12 maanden.</li>
                  <li>Daarna laten de buisjes meestal vanzelf los.</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>`,
      button: 'Volgende',
    },
    {
      path: '/stap-4/vocht/verschillen-op-een-rijtje',
      routeId: 'P3-026',
      nextRouteId: 'P3-027',
      type: 'explanation',
      title: 'Verschillen op een rijtje',
      align: 'left',
      titleAlign: 'center',
      description: `
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Afwachten</th>
              <th>een operatie</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Wat betekent het?</th>
              <td>Geen trommelvlies-buisjes plaatsen.</td>
              <td>Een operatie waarbij uw kind narcose krijgt. De kno-arts plaatst buisjes in het trommelvlies. Buisjes laten na 6 tot 12 maanden meestal vanzelf los.</td>
            </tr>
            <tr>
              <th>Wat kan ik verwachten?</th>
              <td><ul style="margin-top: 0">
                <li>75 van de 100 kinderen hebben na 6 maanden geen vocht meer achter het trommelvlies. Zij horen dan weer goed.</li>
                </ul>
              </td>
              <td>
                <ul style="margin-top: 0">
                  <li>26 van de 100 kinderen krijgen een loopoor.</li>
                  <li>Bij 3 van de 100 groeit het trommelvlies niet dicht nadat het buisje heeft losgelaten.</li>
                  <li>Bij 20 van de 100 kinderen die buisjes hebben gehad en opnieuw klachten krijgen, kiezen de ouders weer voor buisjes.</li>
                </ul>
                <br/>
                Vocht achter het trommelvlies<br/>
                <ul style="margin-top: 0">
                  <li>Uw kind hoort bijna altijd meteen beter. Dit blijft zo zolang de buisjes in de oren zitten. Het is onzeker of kinderen beter gaan praten of gedragsproblemen verminderen.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Voordelen</th>
              <td>
                <ul>
                  <li>Niet de ongemakken van een operatie.</li>
                  <li>Meestal niet naar het ziekenhuis.</li>
                  <li>Geen kans op klachten door de narcose.</li>
                  <li>U kunt later toch nog kiezen voor buisjes.</li>
                </ul>
              </td>
              <td>
              <ul>
                <li>Meteen beter horen.</li>
                <li>6 tot 12 maanden beter horen (tot de buisjes loslaten).</li>
              </ul>
              </td>
            </tr>
            <tr>
              <th>Nadelen</th>
              <td>
                <ul>
                  <li>Het duurt langer voordat de klachten over zijn.</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Ongemakken van een operatie.</li>
                  <li>Ter voorbereiding op de operatie krijgt u een afspraak in het ziekenhuis bij de verdovingsarts of verpleegkundige.</li>
                  <li>Kans op klachten door de narcose.</li>
                  <li>Meer kans op een loopoor.</li>
                  <li>De meeste buisjes werken 6 tot 12 maanden.</li>
                  <li>Daarna laten de buisjes meestal vanzelf los.</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>`,
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P3-027',
      nextRouteId: 'P3-028',
      type: 'question',
      title: 'Wat verwacht u van afwachten?',
      questions: [
        {
          placeholder:
            'Bijvoorbeeld: de ongemakken van de operatie vermijden; flexibiliteit om later toch een andere keuze te kunnen maken.',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-2',
      routeId: 'P3-028',
      nextRouteId: 'P3-029',
      type: 'question',
      title: 'Wat verwacht u van de operatie?',
      questions: [
        {
          placeholder:
            'Bijvoorbeeld: beter kunnen horen; beter slapen voor uw kind en u als ouder; minder last van de oren.',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-3',
      routeId: 'P3-029',
      nextRouteId: 'P3-030',
      subtitle: 'Maak een keuze',
      title: 'Wat heeft uw voorkeur?',
      type: 'uniqueQuestion',
      answers: [
        { title: 'Afwachten tot de klachten zelf overgaan, niet opereren' },
        { title: 'Klachten zo snel mogelijk over, ook als mijn kind geopereerd wordt' },
        { title: 'Geen voorkeur' },
      ],
    },
    {
      path: '/stap-4/vraag-4',
      routeId: 'P3-030',
      nextRouteId: 'P3-031',
      subtitle: 'Stelling',
      title: 'Ik ben bang voor een narcose bij mijn kind.',
      type: 'likertScale',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-5',
      routeId: 'P3-031',
      nextRouteId: 'P3-032',
      subtitle: 'Stelling',
      title: 'Een operatie veroorzaakt ongemak.',
      type: 'likertScale',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-6',
      routeId: 'P3-032',
      nextRouteId: 'P3-033',
      type: 'uniqueQuestion',
      title: 'Wat wilt u?',
      subtitle: 'Maak een keuze',
      answers: [
        { title: 'Afwachten' },
        { title: 'Trommelvlies-buisjes' },
        {
          title: 'Geen voorkeur',
          nextRouteId: 'P3-035',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-7',
      routeId: 'P3-033',
      nextRouteId: 'P3-034',
      type: 'likertScale',
      title: 'Hoe zeker bent u van wat u wilt?',
      subtitle: 'Maak een keuze',
      answers: [
        { title: 'Heel onzeker' },
        { title: 'Onzeker' },
        { title: 'Weet ik nog niet' },
        { title: 'Zeker' },
        { title: 'Heel zeker' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-8',
      routeId: 'P3-034',
      nextRouteId: 'P3-035',
      type: 'question',
      title: 'Waarom?',
      questions: [
        {
          placeholder: 'Licht uw keuze toe',
          type: 'textarea',
        },
      ],
      button: 'Door naar uw antwoorden',
    },
    {
      path: '/print-overview',
      routeId: 'P3-035',
      nextRouteId: 'end',
      type: 'end',
      description: 'U bent klaar met het invullen van de keuzehulp. Bekijk nu uw antwoorden.',
    },
  ],
}

export default trommelvliesBuisjes
